<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-lg">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white" v-if="updating === true">
                                                Update User `{{ form.first_name }} {{ form.last_name }}`
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white" v-else>
                                                Create User
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300" v-if="updating === false">
                                                Get started by filling in the information below to create a new
                                                user.
                                            </p>
                                            <p class="text-sm text-indigo-300" v-else>
                                                Make any changes to the user by updating the information below.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="pt-6 pb-5 grid grid-cols-2 gap-4">
                                                <div>
                                                    <label for="first_name"
                                                           class="block text-sm text-gray-900">
                                                        First Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="first_name" v-model="form.first_name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.first_name}"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="last_name"
                                                           class="block text-sm text-gray-900">
                                                        Last Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.last_name" id="last_name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.last_name}"
                                                        />

                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="credit_card_name"
                                                           class="block text-sm text-gray-900">
                                                        Legal/Credit Card Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.credit_card_name" id="credit_card_name"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.credit_card_name}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="code"
                                                           class="block text-sm text-gray-900">
                                                        Code
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.code" id="code"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.code}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="job_title"
                                                           class="block text-sm text-gray-900">
                                                        Job Title
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.job_title"
                                                               id="job_title"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.job_title}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="telephone"
                                                           class="block text-sm text-gray-900">
                                                        Telephone
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.telephone"
                                                               id="telephone"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.telephone}"

                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="mobile"
                                                           class="block text-sm text-gray-900">
                                                        Mobile
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.mobile" id="mobile"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.mobile}"

                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="email"
                                                           class="block text-sm text-gray-900">
                                                        Email
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" v-model="form.email" id="email"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.email}"

                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="role"
                                                           class="block text-sm text-gray-900">
                                                        Role
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="role" name="role" v-model="form.role" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                                                            <option disabled value="">Select a role</option>
                                                            <option v-for="role in roles" :value="role.name" v-html="role.name"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="role"
                                                           class="block text-sm text-gray-900">
                                                        Trading Details
                                                    </label>
                                                    <div class="mt-1">
                                                        <v-select multiple class="h-full mt-1" :options="trading_details" label="display_name" :reduce="trading_detail => trading_detail.id" v-model="form.trading_details" placeholder="Please Select" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="updating === false" class="pt-4 pb-6">
                                                <div class="mt-4 flex text-sm">
                                                    <div
                                                       class="inline-flex items-center text-gray-500">
                                                        <ExclamationCircleIcon
                                                            class="h-16 w-16 block text-gray-400"
                                                            aria-hidden="true"/>
                                                        <span class="ml-2">
                                                          Once submitted, the user will receive an email inviting them to create a password and log onto the system.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {useForm} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";


export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        ExclamationCircleIcon,
        XIcon,
    },
    setup(prop, context) {

        const show = ref(false)

        const showErrors = ref(false)

        const updating = false;

        const roles = ref([]);
        
        const trading_details = ref([]);

        const form = useForm({
            id: null,
            first_name: null,
            last_name: null,
            credit_card_name: null,
            code: null,
            job_title: null,
            telephone: null,
            mobile: null,
            email: null,
            role: null,
            trading_details: null
        })

        function submit() {
            if (this.updating) {
                this.form.post(route('admin.users.user.update', this.form.id), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            } else {
                this.form.post(route('admin.users.create'), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            }
        }

        function close() {
            this.show = false;
            this.form.reset();
            this.form.clearErrors();
        }

        function open() {
            this.form.clearErrors();
            this.show = true;
        }

        return {
            show,
            form,
            submit,
            updating,
            close,
            open,
            showErrors,
            roles,
            trading_details
        }
    },
}
</script>
